<template>
  <form>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Profile description</h1>

        <a @click="$router.go(-1)" class="btn btn-info"><i class="fa fa-chevron-left"></i> Back</a>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">

        <div class="row">
          <div class="col-md-10 col-lg-8">

            <div class="alert-large alert-large-info">
              <div class="icon-container">
                <i class="fa fa-question"></i>
              </div>
              <div class="alert-content">
                <p class="lead m-b-none">Add a description about yourself</p>
                <p class="no-margin">The first paragraph below will be visible without expanding to see the full content.</p>
              </div>
            </div>

            <div id="redactor-intro-box">
              <redactor
                v-model="stateDescription"
                name="description"
                >
              </redactor>
            </div>

            <ladda-button
              type="submit"
              class="btn btn-primary"
              :click="handleUpdateDescriptionCallback">
              Save Changes
            </ladda-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { stateMapper } from 'mixins/users'
import Redactor from 'codium-redactor'
import { notify } from 'utils'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [stateMapper, OpportunityTracker],

  components: {
    Redactor
  },

  methods: {
    ...mapActions('user', ['updateUser']),

    handleUpdateDescriptionCallback () {
      return this.updateUser({
        id: this.user.id,
        payload: {
          profile: {
            description: this.user.profile.description
          }
        }
      }).then(() => {
        notify.success('Successfully saved description.')
        this.trackEvent(this.analytics.V2.AccountSectionEditEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.DESCRIPTION })
      }).catch((errors) => {
        notify.error('Sorry something has gone wrong, please try again.')
      })
    }
  }
}
</script>
